// extracted by mini-css-extract-plugin
module.exports = {"bet":"BetLines_bet__1Oc0p","banco":"BetLines_banco__mTe7r","betSystemWrap":"BetLines_betSystemWrap__16SIB","emptyMessage":"BetLines_emptyMessage__2w5YQ"};